/*eslint react-hooks/exhaustive-deps: "off"*/
import React, {useEffect, useState} from "react";
import {Alert, Button, Descriptions, Spin, Tabs} from "antd";
import {getApiHost, getLastDomByClassName, numberWithCommas} from "../../../utils";
import Axios from "axios";
import useDebounce from "../../../utils/hooks/useDebounce";
import loadJS from "load-js";
import usePortal from "react-useportal";
import {Title} from "../widgets/Common";

const RMateChartTable5G = ({cusList}) => {
  const chartProfile = window.CHART_PROFILE || "test";
  const [isInit, setIsInit] = useState(false);
  // loadJS로 필요한 목록을 가져온다
  useEffect(() => {
    loadJS([
      `/js/chart/LicenseKey/${chartProfile}/rMateChartH5License.js`,
      "/js/chart/rMateIntegrationH5.js",
      "/js/chart/theme.js",
      "/js/chart/shCore.js",
      "/js/chart/shBrushJScript.js",
      "/gis_5g.js",
    ]).then(() => {
      setIsInit(true);
    });
  }, []);

  const [visible, setVisible] = useState(true);

  // as-is의 데이터 통신 사용하기 - 지역별 정보
  const [tableDistrictData, setTableDistrictData] = useState();
  const [chartDistrictData, setChartDistrictData] = useState();
  const [chartDistrictLayout, setChartDistrictLayout] = useState();
  // eslint-disable-next-line no-unused-vars
  const [districtDataMax, setDistrictDataMax] = useState();
  // eslint-disable-next-line no-unused-vars
  const [districtDataInterval, setDistrictDataInterval] = useState();
  const [isDownloadingDistrict, setIsDownloadingDistrict] = useState(false);
  const [errorDistrict, setErrorDistrict] = useState();
  const [isHiddenChartDistrict, setIsHiddenChartDistrict] = useState(true);
  const [prevData, setPrevData] = useState();
  const [dateData, setDateData] = useState();
  // 지역코드 오류인 데이터는 걸러서 세팅함
  const removeErrorData = (dataList) => {
    if(dataList && dataList.length > 0){
      return dataList.filter(data => data.disNm !== '지역코드오류');
    } else {
      return dataList;
    }
  };

  const getTableData = async ({relUrl, setData, setLoading, setError, gubunCode, setMax, setInterval, setHidden}) => {

    const url = getApiHost() + relUrl;

    const formData = new FormData();
    formData.append('gisViewId', '');
    formData.append('frq_hz', '');
    formData.append('eqm_yn', '');
    formData.append('searchSid', '');
    formData.append('gubun', gubunCode); // 지역별 무선국 수 1

//dispDate: "20191130

    setData({}); // 초기화

    Axios.post(url, formData)
      .then(response => {
        const {data} = response;
        const dataList = removeErrorData(data['rows']);

        if(dataList){
          const year = dataList[0]['dispDate'].substr(0,4);
          const month = dataList[0]['dispDate'].substr(4,2);
          const date = dataList[0]['dispDate'].substr(6,2);
          setDateData(year+'. '+month+'. '+date);
          const dataMax = data['maximum'];
          const dataInterval = data['interval'];
          setInterval(dataInterval);
          setMax(dataMax);
          setData(dataList);
          if (JSON.stringify(prevData) !== JSON.stringify(dataList)) {
            setLoading(true);
            setHidden(true);
            if (gubunCode === '1') {
              setLoading(false);
              try {
                window.rMateChartH5.instances.chart1.destroy();
              } catch {
              }
              chartDistrict(dataList, dataMax, dataInterval).then(r => {
                setPrevData(dataList);
              });
            }
          }
        }

      }).catch(e => {
      setError(e);
      console.error(e);
    }).finally(() => {
    });
  };

  useDebounce(
    () => {
      if (visible) {
        if (!prevData) {
          setIsDownloadingDistrict(true);
        }
        if (isInit) {
          getTableData({
            relUrl: '/gis/gis_5g_stats.json',
            setData: setTableDistrictData,
            setLoading: setIsDownloadingDistrict,
            setError: setErrorDistrict,
            gubunCode: '1', // 장치별 정보
            setMax: setDistrictDataMax,
            setInterval: setDistrictDataInterval,
            setHidden: setIsHiddenChartDistrict,
          });

        }
      }
    },
    0,
    [visible, isInit],
  );


  async function chartDistrict(dataList, dataMax, dataInterval) {
    if (dataList && dataList.length > 0) {
      const chartData = await dataZeroRemoveFn(dataList);
      const chartLayout = await setChartLayoutBar(dataMax, dataInterval);
      await setChartDistrictData(chartData);
      await setChartDistrictLayout(chartLayout);
      await setIsHiddenChartDistrict(false);
    }
  }

  useEffect(() => {
    if (isHiddenChartDistrict === false) {
      window._staData = chartDistrictData;
      window.layoutStr = chartDistrictLayout;
      window.chartCreateInfo();
    }
  }, [isHiddenChartDistrict]);


  const {Portal} = usePortal({
    bindTo: getLastDomByClassName('toolbar-show-chart'),
  });

  return (
    <>
      <Portal>
        <Button type={visible ? "primary" : undefined}
                onClick={() => setVisible(true)}>
          차트 보기
        </Button>
      </Portal>

      <div style={CHART_PANE_STYLE} hidden={!visible}>
        <Tabs defaultActiveKey={"district"} type={"card"}>
          <Tabs.TabPane tab="지역별 정보" key={"district"}>
            <>
              <div style={STYLE_SUBMIT}>
                <Button onClick={() => setVisible(false)}>
                  닫기
                </Button>
              </div>
              <div style={STYLE_CONTENT}>
                {errorDistrict &&
                <Alert message={"데이터 로딩에 실패했습니다. 잠시 후 다시 시도해주세요."} type={"error"}/>
                }
                {isDownloadingDistrict && <Spin size="large">
                  <Alert
                    message="데이터 로딩중"
                    description="5G 무선국 정보를 가져오고 있습니다."
                    type="info"
                  />
                </Spin>
                }
                {!errorDistrict && tableDistrictData && !isDownloadingDistrict && tableDistrictData.length > 0 &&
                <>
                  <Title children={'총 ' + tableDistrictData.length + '지역의 ' +
                  numberWithCommas(tableDistrictData.reduce((prev, next) => prev + next.cnt, 0)) + '개 5G 기지국 '}
                         extra={`( ${dateData} 기준)`}/>
                  <br/>
                  <Descriptions bordered
                                size={"small"}
                                column={3}>
                    {tableDistrictData.map(({disNm, cnt}) =>
                      <Descriptions.Item key={disNm} label={disNm}>{numberWithCommas(cnt)}</Descriptions.Item>
                    )}
                  </Descriptions>
                </>
                }
              </div>
              <br/>
              {isDownloadingDistrict === false &&
              <div style={CHART_CONTAINER_STYLE}>
                <div id={"chartHolder"} style={CHART_HOLDER_STYLE}/>
              </div>
              }
            </>
          </Tabs.TabPane>
        </Tabs>
      </div>
    </>
  );
};
const CHART_PANE_STYLE = {
  position: 'absolute',
  padding: '14px',
  margin: '8px',
  background: 'rgba(255, 255, 255, 1)',
  right: 36,
  top: 76,
  width: '700px',
  height: '700px',
  overflowX: 'auto',
  overflowY: 'auto',
  border: '1px solid grey',
  zIndex: 1,
};


const STYLE_CONTENT = {
  height: '100%',
  marginBottom: '30px',
};


const STYLE_SUBMIT = {
  position: 'absolute',
  top: -10,
  right: 2,
  padding: '10px 12px',
};


const CHART_HOLDER_STYLE = {
  width: '100%',
  height: 500,
};

const CHART_CONTAINER_STYLE = {
  position: 'relative',
  padding: '4px',
  margin: '8px',
  background: 'rgba(255, 255, 255, 0.8)',
  top: 21,
  width: '100%',
  marginTop: '-50px',
};

const dataZeroRemoveFn = (dataList) => {
  if (dataList) {
    return dataList.filter(obj => obj.cnt !== 0);
  }
};
const setChartLayoutBar = (maximum, interval) => {
  return '<rMateChart backgroundColor="#FFFFFF"  borderStyle="none">'
    + '<NumberFormatter id="numfmt" useThousandsSeparator="true"/>'
    + '<Options>'
    + '<Caption text="지역별 무선국 정보 " textAlign="center" />'
    //+'<Caption text="지역별 무선국 정보 &lt;a href=javascript:cartDownload(\'chart1\')&gt;&lt;img src=\'/images/chart/chartsave.png\' title=\'차트이미지저장\'&gt; &lt;/a&gt; &lt;a onclick=cartCsvDownloadcartId(\'chart1\')&gt;&lt;img  src=\'/images/chart/chart_download.png\' title=\'차트CSV저장\'&gt;&lt;/a&gt;" textAlign="center" />'
    + '</Options>'
    + '<HistoryChart>'
    + '<displayerChart>'
    + '<Displayer id="chart1" dataTipJsFunction="dataTipFuncHis" showDataTips="true" width="100%" height="100%">'
    + '<horizontalAxis>'
    + '<CategoryAxis id="mainHAxis" categoryField="disNm" ticksBetweenLabels="true" padding="0.5" labelJsFunction="labelFunc"/>'
    + '</horizontalAxis>'
    + '<horizontalAxisRenderers>'
    + '<Axis2DRenderer axis="{mainHAxis}"  canDropLabels="false" labelRotation="0" fontSize="11" showLine="true"/>'
    /* labelRotation 수치라벨을 기울입니다. */
    + '</horizontalAxisRenderers>'
    + '<verticalAxis>'
    + '<LinearAxis maximum="' + maximum + '" interval="' + interval + '" formatter="{numfmt}" />'
    + '</verticalAxis>'
    + '<series>'
    + '<Column2DSet type="clustered" columnWidthRatio="0.5">'
    + '<series>'
    + '<Column2DSeries id="columnSeries" yField="cnt" displayName="Data1">'
    + '<fill>'
    + '<SolidColor color="#41b2e6"/>'
    + '</fill>'
    /* 디스플레이어 차트로 Column2DSeries를 정의 하였습니다 */
    + '<showDataEffect>'
    + '<SeriesInterpolate duration="1000"/>'
    + '</showDataEffect>'
    + '</Column2DSeries>'
    + '</series>'
    + '</Column2DSet>'
    + '</series>'
    + '</Displayer>'
    + '</displayerChart>'
    + '<navigator>'
    + '<Navigator id="navi" width="100%"  height="40" gutterLeft="0" gutterBottom="0" paddingLeft="2" paddingRight="2">'
    + '<horizontalAxis>'
    + '<CategoryAxis categoryField="disNm" id="naviHAxis"  padding="0"/>'
    + '</horizontalAxis>'
    + '<horizontalAxisRenderers>'
    + '<Axis2DRenderer axis="{naviHAxis}" visible="false"/>'
    + '</horizontalAxisRenderers>'
    + '<verticalAxis>'
    + '<LinearAxis id="vAxis"/>'
    + '</verticalAxis>'
    + '<verticalAxisRenderers>'
    + '<Axis2DRenderer axis="{vAxis}" visible="false"/>'
    + '</verticalAxisRenderers>'
    + '<backgroundElements>'
    + '<GridLines direction="horizontal"/>'
    + '</backgroundElements>'
    + '<series>'
    + '<Column2DSeries yField="cnt">'
    + '<fill>'
    + '<SolidColor color="#074d81"/>'
    + '</fill>'
    + '</Column2DSeries>'
    + '</series>'
    + '</Navigator>'
    + '</navigator>'
    + '<selector>'/* 시작 시 보여지는 차트는 총 데이터의 약 40%이며 센터 영역입니다. */
    + '<HistoryRangeSelector width="100%" startingRange="center" visibleItemSize="35"/>'
    + '</selector>'
    + '</HistoryChart>'
    + '</rMateChart>';
};
export default RMateChartTable5G;
